// React hooks
import { createContext, useState, useEffect } from "react";
// Services
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const AuthContext = createContext();

function AuthWrapper(props) {
  // * Global States
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState("");
  const [isFetching, setIsFetching] = useState(true);
  const [isAdmin, setisAdmin] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    authenticateUser();
  }, []);

  useEffect(() => {
    if (userId) {
      getUserData();
    }
  }, [userId]);

  const authenticateUser = () => {
    console.log("entrando en authenticateUser");
    setIsFetching(true);
    const auth = getAuth(); // Firebase v9+ no necesita await aquí, es sincrónico
    
    try {
      onAuthStateChanged(auth, (authUser) => {
        if (authUser) {
          console.log("🚀 Usuario detectado en Firebase Auth:", authUser.uid);
          setUserId(authUser.uid);
          setIsLoggedIn(true);
          // Ojo: No apagamos isFetching aquí. Esperamos a que getUserData 
          // traiga el rol desde Firestore para evitar saltos visuales en la UI.
        } else {
          console.log("No hay usuarios activos");
          setisAdmin(false);
          setIsLoggedIn(false);
          setUserId("");
          setUser(null);
          setIsFetching(false);
        }
      });
    } catch (error) {
      console.log("Error en el listener de autenticación:", error);
      setIsFetching(false);
    }
  };

  const getUserData = async () => {
    console.log("entrando en getUserData para la ID:", userId);
    if (!userId) return;

    try {
      setIsFetching(true);
      const userRef = doc(db, "users", userId);
      const userById = await getDoc(userRef);
      const userData = userById.data();

      if (userById.exists() && userData) {
        console.log("Datos de la Database cargados:", userData);
        setUser(userData);
        
        // 🔥 Comprobación dinámica del rol guardado en Firestore
        if (userData.role === "admin") {
          console.log("👑 Acceso concedido: El usuario es Administrador");
          setisAdmin(true);
        } else {
          console.log("👤 Acceso estándar: El usuario es Usuario Básico");
          setisAdmin(false);
        }
      } else {
        console.log("El documento del usuario no existe en la colección 'users'");
        setisAdmin(false);
      }
      
      setIsFetching(false);
    } catch (error) {
      console.log("No se ha podido cargar el usuario de la base de datos:", error);
      setIsFetching(false);
    }
  };

  const passedContext = {
    isAdmin,
    isLoggedIn,
    user,
    getUserData,
    authenticateUser,
    setIsLoggedIn,
    setUserId
  };

  if (isFetching) {
    // Corregido 'class' por 'className' (React estándar)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Cargando perfil...</span>
        </div>
      </div>
    );
  }

  return <AuthContext.Provider value={passedContext}>{props.children}</AuthContext.Provider>;
}

export { AuthContext, AuthWrapper };